import React from "react";
import Loading from "../../common/loading/Loading";
import { connect } from "react-redux";
import { loadAvailableHoursHistory } from "../../../redux/actions/AvailableHoursActions";
import { loadHoursTransactionTypes } from "../../../redux/actions/UtilityActions";
import { LOAD_AVAILABLE_HOURS_HISTORY_SUCCESS } from "../../../redux/actions/ActionTypes";
import { Form } from "react-bootstrap";
import FormRow from "../../common/forms/FormRow";
import ConsultantFNFilter from "../common/searchFilters/ConsultantFNFilter";
import ConsultantLNFilter from "../common/searchFilters/ConsultantLNFilter";
import RateFilter from "../common/searchFilters/RateFilter";
import HoursTransactionTypeFilter from "../common/searchFilters/HoursTransactionTypeFilter";
import DataGrid from "../../common/DataGrids/DataGrid";
import Page from "../../common/Page";

class AccountHistoryPage extends React.Component {
  render() {
    return (
      <Page
        pageTitle="Account History"
        pageHeader={
          this.props.profile.isAdmin && !this.props.profile.ghost ? (
            <Form>
              <FormRow
                columns={[
                  <ConsultantFNFilter
                    onChange={this.filterResults}
                    names={[...new Set(this.props.availableHoursHistory.map((i) => i.consultantFirstName))]}
                    ref={(element) => (this.consultantFNFilter = element)}
                  />,
                  <ConsultantLNFilter
                    onChange={this.filterResults}
                    names={[...new Set(this.props.availableHoursHistory.map((i) => i.consultantLastName))]}
                    ref={(element) => (this.consultantLNFilter = element)}
                  />,
                  <RateFilter
                    onChange={this.filterResults}
                    rates={[...new Set(this.props.availableHoursHistory.map((i) => i.rate))]}
                    ref={(element) => (this.rateFilter = element)}
                  />,
                  <HoursTransactionTypeFilter
                    onChange={this.filterResults}
                    types={this.props.hoursTransationTypes}
                    ref={(element) => (this.transactionTypeFilter = element)}
                  />,
                ]}
              />
            </Form>
          ) : null
        }
      >
        <Loading api={LOAD_AVAILABLE_HOURS_HISTORY_SUCCESS} />
        <DataGrid
          adminHeaders={this.state.adminHeaders}
          data={this.state.filtered ? this.state.filteredResults : this.props.availableHoursHistory}
          headers={this.state.headers}
          isAdmin={this.props.profile.isAdmin}
          isGhosting={this.props.profile.ghost}
        />
      </Page>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      filteredResults: this.props.availableHoursHistory,
      filtered: false,
      ghost: null,
      adminHeaders: [{ label: "Name", key: "consultantName" }],
      headers: [
        { label: "Type", key: "transactionType" },
        { label: "Hours", key: "hours" },
        { label: "Rate", key: "rate" },
        { label: "Transaction Date Time", key: "transactionDateTime" },
      ],
    };

    this.filterResults = this.filterResults.bind(this);
  }

  componentDidMount() {
    this.props.loadAvailableHoursHistory(this.props.profile.isAdmin, this.props.profile.ghost).catch((error) => {
      alert(error);
    });
    this.props.loadHoursTransactionTypes().catch((error) => {
      throw error;
    });
    this.setState({ ghost: this.props.profile.ghost });
  }

  componentDidUpdate() {
    if (this.props.profile.ghost !== this.state.ghost) {
      this.props.loadAvailableHoursHistory(this.props.profile.isAdmin, this.props.profile.ghost).catch((error) => {
        alert(error);
      });
      this.setState({ ghost: this.props.profile.ghost });
    }
  }

  filterResults() {
    let results = this.state.filteredResults;
    if (
      this.consultantFNFilter.value === "All" ||
      this.consultantLNFilter.value === "All" ||
      this.rateFilter.value === "All" ||
      this.transactionTypeFilter.value !== "All"
    ) {
      results = this.props.availableHoursHistory;
    }
    if (this.consultantFNFilter.value !== "All") {
      results = results.filter((row) => row.consultantFirstName === this.consultantFNFilter.value);
    }
    if (this.consultantLNFilter.value !== "All") {
      results = results.filter((row) => row.consultantLastName === this.consultantLNFilter.value);
    }
    if (this.rateFilter.value !== "All") {
      results = results.filter((row) => row.rate === this.rateFilter.value);
    }
    if (this.transactionTypeFilter.value !== "All") {
      results = results.filter((row) => row.transactionType === this.transactionTypeFilter.value);
    }
    this.setState({ filteredResults: results, filtered: true });
  }
}

function mapStateToProps(state, ownProps) {
  return {
    availableHoursHistory: state.availableHoursHistory,
    hoursTransationTypes: state.hoursTransationTypes,
    profile: state.profile,
  };
}

const mapDispatchToProps = {
  loadAvailableHoursHistory,
  loadHoursTransactionTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountHistoryPage);
